import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { decryptdata } from '../utils/crypto';

const httpLink = createHttpLink({
    uri: `${process.env.REACT_APP_API_URL}/graphql/`,
  });

  const authLink = setContext((_, { headers }) => {
    let value = decryptdata(localStorage.getItem('token'))
    const token = value
    return {
      headers: {
        ...headers,
        authorization: token ? `${token}` : "",
      }
    }
  });

  export const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
   
  });